/**
 *
 */
export function useIndicatorPosition(): {
  isInitialized: () => boolean;
  updateIndicatorPosition: (
    indicatorElement: HTMLElement | null,
    tabsContainerElement: HTMLElement | null,
    tabs: HTMLElement[],
    selectedIndex: number,
    scrollLeft: number,
  ) => void;
} {
  let isInitialized = $state(false);

  function updateIndicatorPosition(
    indicatorElement: HTMLElement | null,
    tabsContainerElement: HTMLElement | null,
    tabs: HTMLElement[],
    selectedIndex: number,
    scrollLeft: number,
  ): void {
    if (!indicatorElement || !tabs[selectedIndex]) return;

    const selectedTab = tabs[selectedIndex];
    const interactiveElement = selectedTab.querySelector("button, a") as HTMLElement;

    if (!interactiveElement || !tabsContainerElement) return;

    const containerRect = tabsContainerElement.getBoundingClientRect();
    const tabRect = interactiveElement.getBoundingClientRect();

    /*                                                                     */
    const left = tabRect.left - containerRect.left + scrollLeft - 2;
    const width = tabRect.width + 4;

    /*                                               */
    const bottom = containerRect.bottom - tabRect.bottom;

    indicatorElement.style.transform = `translateX(${left}px)`;
    indicatorElement.style.width = `${width}px`;
    indicatorElement.style.bottom = `${bottom}px`;

    /*                                         */
    if (!isInitialized) {
      requestAnimationFrame(() => {
        isInitialized = true;
      });
    }
  }

  return {
    isInitialized: () => isInitialized,
    updateIndicatorPosition,
  };
}
